import {v4 as uuidv4} from 'uuid'
import { GoodsClassifierPluginSettings } from '../pluginSettings/GoodsClassifierPluginSettings';
import { GoodsClassifierPluginView } from '../GoodsClassifierPluginView';

export const GoodsClassifierTab = (): ITab => {
  return {
    id: uuidv4(),
    title: 'Группы аналогов',
    view: {
      content: GoodsClassifierPluginSettings ? (
        <GoodsClassifierPluginView gridId={uuidv4()} plugin={GoodsClassifierPluginSettings} />
      ) : (
        <p> Справочник не настроен</p>
      ),
    },
  };
};
